import React from 'react';

const InputField = ({ 
  label, 
  type = 'text', 
  value, 
  onChange, 
  placeholder = '', 
  name, 
  step, 
  disabled = false,
  required = false,
  icon = null,
  error = '',
  helperText = '',
  className = ''
}) => {
  return (
    <div className={`mb-4 ${className}`}>
      {label && (
        <label className="block text-xs font-semibold uppercase tracking-wider text-slate-600 dark:text-slate-400 mb-1.5">
          {label}
          {required && <span className="text-rose-500 ml-1">*</span>}
        </label>
      )}
      <div className="relative rounded-lg shadow-sm">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3.5 flex items-center pointer-events-none text-slate-400 dark:text-slate-500">
            {icon}
          </div>
        )}
        <input
          type={type}
          value={value ?? ''}
          onChange={onChange}
          placeholder={placeholder}
          name={name}
          step={step}
          disabled={disabled}
          required={required}
          className={`
            w-full px-3.5 py-2.5 rounded-lg text-sm
            bg-slate-50/70 dark:bg-slate-900/60
            text-slate-900 dark:text-slate-100
            border border-slate-200 dark:border-slate-700
            placeholder:text-slate-400 dark:placeholder:text-slate-500
            focus:bg-white dark:focus:bg-slate-900
            focus:border-emerald-500 dark:focus:border-emerald-500
            focus:ring-2 focus:ring-emerald-500/20
            transition-all duration-200 ease-in-out outline-none
            ${icon ? 'pl-10' : ''}
            ${disabled ? 'opacity-50 cursor-not-allowed bg-slate-100 dark:bg-slate-800' : ''}
            ${error ? 'border-rose-500 focus:border-rose-500 focus:ring-rose-500/20' : ''}
          `}
        />
      </div>
      {error && <p className="mt-1 text-xs text-rose-500">{error}</p>}
      {helperText && !error && <p className="mt-1 text-xs text-slate-400">{helperText}</p>}
    </div>
  );
};

export default InputField;
